import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { PageHeader, Icon } from "antd";

import "./styles.css";
import PropTypes from "prop-types";

class Base extends Component {
  /** Base for pages */

  /** Propriedades desse componente */
  static propTypes = {
    title: PropTypes.string,
    subTitle: PropTypes.string,
    extra: PropTypes.any // Componentes, ou qualquer HTML
  };

  handleBack = () => {
    /** Volta em páginas anteriores */
    try {
      this.props.history.goBack();
    } catch (error) {
      console.log("Não foi possível voltar a página!");
    }
  };

  render() {
    return (
      <div>
        <PageHeader
          onBack={this.handleBack}
          backIcon={<Icon type="arrow-left" />}
          title={this.props.title}
          subTitle={this.props.subTitle}
          extra={this.props.extra}
        />
        <div className="base__container">
          {/* Conteúdo da página */}
          {this.props.children}
        </div>
      </div>
    );
  }
}
export default withRouter(Base);



// WEBPACK FOOTER //
// ./src/components/Base/index.js